import React from 'react';

import { Box } from '@lyearn/ui';

const AppContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  // Page-base surface. `bg-workspace` defaults to white; a workspace custom theme repoints it
  // (via appConfig.theme.palette) so the page canvas is driven entirely by config.
  return (
    <Box className="flex min-h-screen flex-col bg-bg-workspace text-text-primary">{children}</Box>
  );
};

export default AppContainer;
